import { language } from 'utils/literals';
import './PracticeFormLegend.scss';

export const PracticeFormLegend = () => {
  return (
    <ul className="practice-form__legend">
      <li className="practice-form__legend-item">
        {language.informacionPractica.leyendaBorrador}
      </li>
      <li className="practice-form__legend-item">
        {language.informacionPractica.leyendaEnviar}
      </li>
    </ul>
  );
};
